var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkedSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5C9.3495 1.5 8 2.8495 8 4.5C8 4.996 8.1915 5.502 8.4375 6.0625C8.6835 6.623 8.994 7.21712 9.3125 7.76562C9.949 8.86312 10.5938 9.78125 10.5938 9.78125L11 10.375L11.4062 9.78125C11.4062 9.78125 12.0505 8.86312 12.6875 7.76562C13.006 7.21663 13.3165 6.623 13.5625 6.0625C13.8085 5.502 14 4.996 14 4.5C14 2.8495 12.6505 1.5 11 1.5ZM5.98438 2.46875L2 4.17188V13.7656L6.01562 12.0312L10.0156 13.5312L14 11.8281V7.46875C13.6815 8.08025 13.328 8.666 13 9.1875V11.1719L10.5 12.2344V11.4219L9.76562 10.3594C9.68762 10.2459 9.5955 10.1112 9.5 9.96875V12.2812L6.5 11.1562V3.71875L7.04688 3.92188C7.09587 3.58387 7.1835 3.25813 7.3125 2.95312L5.98438 2.46875ZM11 2.5C12.1095 2.5 13 3.3905 13 4.5C13 4.6935 12.8792 5.15025 12.6562 5.65625C12.4338 6.16225 12.119 6.73612 11.8125 7.26562C11.4045 7.96863 11.2285 8.21948 11 8.56348C10.7715 8.21948 10.5955 7.96863 10.1875 7.26562C9.881 6.73612 9.56675 6.16225 9.34375 5.65625C9.12125 5.15025 9 4.6935 9 4.5C9 3.3905 9.8905 2.5 11 2.5ZM5.5 3.75V11.1719L3 12.2344V4.82812L5.5 3.75Z",
    fill: "#303335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkedSolidIcon);
export default __webpack_public_path__ + "static/media/mapMarkedSolidIcon.458713ab72b00117b9a1cab8910dfedc.svg";
export { ForwardRef as ReactComponent };